import { useAuth } from "../context/AuthContext";
import { memo } from "react";
import { Navigate } from "react-router-dom";

export const PublicRoute = memo(function PublicRoute({ children }) {
    const { user } = useAuth();
  
    if (user) {
      return <Navigate to="/dashboard" replace />;
    }
  
    return children;
  });